import { BarChart } from 'components/BarChart'
import { ContentNotAvailable } from 'components/ContentNotAvailable'
import { MainBox } from 'components/MainBox'
import { labelStyles } from 'components/MainComponent/LabelStyles'
import { swissStatsData } from 'components/MainComponent/MainComponent'
import { nfp, Textbuilder } from 'components/MainComponent/textBuilder'
import { TamediaLink } from 'components/TamediaLink'
import { ReadDataFromWindow } from 'components/WindowCommunication'
import { useLabels } from 'Hooks/useLabels'
import { useState } from 'react'

import styled from 'styled-components'

export const Part2 = ({
  tenant,
  colorMode
}: {
  tenant: Tenant | undefined
  colorMode: 'light' | 'dark' | undefined
}) => {
  const [userinputs, setUserInputs] = useState<UserInputsType>({})
  const [voteStats, setvoteStats] = useState<VoteStatsType>({})

  const Labels = useLabels(labelStyles)

  function handleNewData (data: dbDataType) {
    console.log(data, 'data2')
    if (data && data.userinputs && data.userinputs.weight)
      setUserInputs(data.userinputs)
    if (data && data.voteStats && data.voteStats.sum)
      setvoteStats(data.voteStats)
  }

  const lang = tenant?.lang

  return (
    <>
      <ReadDataFromWindow callback={handleNewData} />
      {!userinputs.weight && (
        <>
          <MainBox
            content={
              <div>
                <Labels userRelationBox>
                  {lang === 'de' ? (
                    <>So viel Kaffee trinken Sie im Vergleich</>
                  ) : (
                    <>Voici la quantité de café que vous buvez en comparaison</>
                  )}
                </Labels>
              </div>
            }
          />
          <ContentNotAvailable>
            {lang === 'de' ? (
              <>
                Wie viel Koffein nehmen Sie zu sich? Und ist das viel im
                Vergleich zu anderen Teilnehmenden? Finden Sie es heraus, indem
                Sie ganz oben Ihren Kaffee-Konsum angeben.
              </>
            ) : (
              <>
                Quelle est la quantité de caféine que vous consommez? Est-ce
                beaucoup par rapport aux autres participants?
                Découvrez-le en indiquant tout en haut votre consommation de
                café.
              </>
            )}
          </ContentNotAvailable>
        </>
      )}
      {userinputs.weight && (
        <>
          <MainBox
            content={
              <div>
                {voteStats.potCountAverage &&
                  voteStats.sum &&
                  voteStats.abstinent &&
                  voteStats.caffeineAverage &&
                  !userinputs.sum &&
                  (lang === 'de'
                    ? Textbuilder()
                        .add(
                          'Sie gehören zu den wenigen Teilnehmenden, die keinen Kaffee trinken'
                        )

                        .array()
                        .map((m, i) => (
                          <Labels userRelationBox key={i}>
                            {m}
                          </Labels>
                        ))
                    : Textbuilder()
                        .add('vous ne buvez pas de café,')
                        .break()
                        .add(' tout comme ')
                        .break()
                        .num((voteStats.abstinent * 100) / voteStats.sum, {
                          digits: 1,
                          style: 'percent'
                        })
                        .add(' pour cent')
                        .add(' des autres participants')

                        .array()
                        .map((m, i) => (
                          <Labels userRelationBox key={i}>
                            {m}
                          </Labels>
                        )))}
                {!!(voteStats.caffeineAverage && userinputs.caffeine) &&
                  Textbuilder()
                    .add(lang === 'de' ? 'Sie konsumieren ' : 'Vous consommez ')
                    .compare(userinputs.caffeine, voteStats.caffeineAverage, {
                      '>': lang === 'de' ? 'mehr' : 'plus de',
                      '<': lang === 'de' ? 'weniger' : 'moins de',
                      '=': lang === 'de' ? 'gleichviel' : 'autant de'
                    })
                    .break()
                    .add(lang === 'de' ? 'Koffein ' : 'caféine ')
                    .compare(userinputs.caffeine, voteStats.caffeineAverage, {
                      '>': lang === 'de' ? 'als' : 'que',
                      '<': lang === 'de' ? 'als' : 'que',
                      '=': lang === 'de' ? 'wie' : 'comme'
                    })
                    .add(
                      lang === 'de'
                        ? ' die anderen Teilnehmenden im Schnitt'
                        : ' la moyenne des autres participants'
                    )

                    .break()

                    .array()
                    .map((m, i) => (
                      <Labels userRelationBox key={i}>
                        {m}
                      </Labels>
                    ))}
              </div>
            }
          />

          <p>
            {!!(
              voteStats &&
              voteStats.potCountAverage &&
              voteStats.caffeineAverage &&
              userinputs.caffeine &&
              voteStats.thirds &&
              voteStats.thirds.rangesString &&
              userinputs.sum
            ) && (
              <>
                {lang === 'de'
                  ? Textbuilder()
                      .add('Mit ')
                      .plural(userinputs.sum, {
                        '0': ' Ihren ',
                        '1': ' Ihrer ',
                        '2': ' Ihren '
                      })
                      .num(userinputs.sum)

                      .plural(userinputs.sum, {
                        '0': '  Tassen',
                        '1': '  Tasse',
                        '2': '  Tassen'
                      })
                      .add(' Kaffee pro Tag')
                      .add(' trinken Sie')
                      .compare(userinputs.sum, voteStats.potCountAverage, {
                        '>': ' mehr als',
                        '<': ' weniger als',
                        '=': ' gleichviel wie'
                      })
                      .add(' die meisten anderen Teilnehmenden, deren')
                      .add(' Schnitt bei täglich ')
                      .num(voteStats.potCountAverage, {
                        digits: 1,
                        style: 'percent'
                      })
                      .plural(voteStats.potCountAverage, {
                        '0': ' Tassen',
                        '1': ' Tasse',
                        '2': ' Tassen'
                      })
                      .add(' liegt.')
                      .break()
                      .add(' Der Koffeingehalt')
                      .plural(userinputs.sum, {
                        '0': ' der von Ihnen angegebenen Getränke',
                        '1': ' des von Ihnen angegebenen Getränks',
                        '2': ' der von Ihnen angegebenen Getränke'
                      })
                      .add(' beträgt etwa ')
                      .num(userinputs.caffeine, { digits: 0, style: 'percent' })
                      .add(' Milligramm. ')
                      .break()
                      .add('Das ist')
                      .compare(userinputs.caffeine, voteStats.caffeineAverage, {
                        '>': ' mehr als die',
                        '<': ' weniger als die',
                        '=': ' gleich viel wie die'
                      })
                      .num(voteStats.caffeineAverage, {
                        digits: 0,
                        style: 'percent'
                      })
                      .add(' Milligramm,')
                      .add(' welche die ')
                      .add('anderen Teilnehmenden durchschnittlich')
                      .add(' zu sich nehmen.')

                      .array()
                      .map((m, i) => {
                        if ([1, 4, 10].includes(i)) {
                          return (
                            <Labels userRelation key={i}>
                              {m}
                            </Labels>
                          )
                        }

                        return <span key={i}>{m}</span>
                      })
                  : Textbuilder()
                      .add('avec ')
                      .plural(userinputs.sum, {
                        '0': ' vos ',
                        '1': ' votre ',
                        '2': ' vos '
                      })
                      .num(userinputs.sum)

                      .plural(userinputs.sum, {
                        '0': '  tasses',
                        '1': '  tasse',
                        '2': '  tasses'
                      })
                      .add(' de café par jour')
                      .add(' vous buvez')
                      .compare(userinputs.sum, voteStats.potCountAverage, {
                        '>': ' plus que',
                        '<': ' moins que',
                        '=': ' autant que'
                      })
                      .add(' la plupart des autres participants, dont le')
                      .add(' nombre moyen de tasses par jour est de ')
                      .num(voteStats.potCountAverage, {
                        digits: 1,
                        style: 'percent'
                      })
                      .plural(voteStats.potCountAverage, {
                        '0': ' tasse',
                        '1': ' tasses',
                        '2': ' tasses'
                      })
                      .add(' .')
                      .break()
                      .add(' Le contenu en caféine')
                      .plural(userinputs.sum, {
                        '0': ' des boissons que vous avez indiquées',
                        '1': ' de la boisson que vous avez indiquée',
                        '2': ' des boissons que vous avez indiquées'
                      })
                      .add(' est d’environ ')
                      .num(userinputs.caffeine, { digits: 0, style: 'percent' })
                      .add(' milligrammes. ')
                      .break()
                      .add('C’est')
                      .compare(userinputs.caffeine, voteStats.caffeineAverage, {
                        '>': ' plus que la',
                        '<': ' moins que la',
                        '=': ' autant que la'
                      })
                      .num(voteStats.caffeineAverage, {
                        digits: 0,
                        style: 'percent'
                      })
                      .add(' milligrammes,')
                      .add(' que la ')
                      .add(
                        'plupart des autres participants prennent en moyenne'
                      )
                      .add(' . Avec votre consommation ')
                      .range(userinputs.caffeine, {
                        [voteStats.thirds.rangesString[0]]:
                          'vous appartenez donc aux buveurs de café les moins nombreux.',
                        [voteStats.thirds.rangesString[1]]:
                          'vous vous trouvez donc dans la moyenne.',
                        [voteStats.thirds.rangesString[2]]:
                          'vous appartenez donc aux buveurs de café les plus nombreux.'
                      })
                      .array()
                      .map((m, i) => {
                        if ([1, 4, 10].includes(i)) {
                          return (
                            <Labels userRelation key={i}>
                              {m}
                            </Labels>
                          )
                        }
                      })}
              </>
            )}
            {!!(
              voteStats &&
              voteStats.potCountAverage &&
              voteStats.abstinent &&
              voteStats.caffeineAverage &&
              !userinputs.caffeine &&
              voteStats.thirds &&
              voteStats.sum &&
              voteStats.thirds.rangesString &&
              !userinputs.sum
            ) && (
              <>
                {lang === 'de'
                  ? Textbuilder()
                      .add('Sie trinken keinen Kaffee,')
                      .add(' ebenso wie ')
                      .num((voteStats.abstinent * 100) / voteStats.sum, {
                        digits: 1,
                        style: 'percent'
                      })
                      .add(' Prozent der anderen der Teilnehmenden')
                      .break()
                      .add(' Der')
                      .break()
                      .add(' Durchschnitt')
                      .break()
                      .add(' der Umfrage liegt bei ')
                      .break()
                      .num(voteStats.potCountAverage, { digits: 0 })
                      .plural(voteStats.potCountAverage, {
                        '0': ' Kaffee',
                        '1': ' Kaffees',
                        '2': ' Kaffees'
                      })
                      .add('und ')
                      .break()
                      .num(voteStats.caffeineAverage, { digits: 0 })
                      .add(' Milligramm Koffein pro Tag')
                      .array()
                      .map((m, i) => {
                        if ([0].includes(i)) {
                          return (
                            <Labels userRelation key={i}>
                              {m}
                            </Labels>
                          )
                        }
                        // if ([2, 4, 6, 8].includes(i)) {
                        //   return (
                        //     <span key={i}>
                        //       <b>{m}</b>
                        //     </span>
                        //   )
                        // }
                        return <span key={i}>{m}</span>
                      })
                  : Textbuilder()
                      .add('Vous ne buvez pas de café,')
                      .add(' tout comme ')
                      .num((voteStats.abstinent * 100) / voteStats.sum, {
                        digits: 0,
                        style: 'percent'
                      })
                      .add(' pour cent des autres participants')
                      .break()
                      .add(' La')
                      .break()
                      .add(' moyenne')
                      .break()
                      .add(' de l’enquête est de ')
                      .break()
                      .num(voteStats.potCountAverage, { digits: 0 })
                      .plural(voteStats.potCountAverage, {
                        '0': ' café',
                        '1': ' cafés',
                        '2': ' cafés'
                      })
                      .add('et ')
                      .break()
                      .num(voteStats.caffeineAverage, { digits: 0 })
                      .add(' milligrammes de caféine par jour')
                      .array()
                      .map((m, i) => {
                        if ([0].includes(i)) {
                          return (
                            <Labels userRelation key={i}>
                              {m}
                            </Labels>
                          )
                        }
                        // if ([2, 4, 6, 8].includes(i)) {
                        //   return (
                        //     <span key={i}>
                        //       <b>{m}</b>
                        //     </span>
                        //   )
                        // }
                        return <span key={i}>{m}</span>
                      })}
              </>
            )}
          </p>
          <TwoCols>
            <BarChartTextCol className='left'>
              <Labels chartTitleNm>
                {lang === 'de' ? (
                  <>
                    So viel Koffein konsumieren Sie im Vergleich mit den anderen{' '}
                    {voteStats.sum && voteStats.sum > 9999
                      ? voteStats.sum?.toLocaleString('de-CH')
                      : voteStats.sum}{' '}
                    Teilnehmenden
                  </>
                ) : (
                  <>
                    Voici la quantité de caféine que vous consommez par rapport
                    aux{' '}
                    {voteStats.sum && voteStats.sum > 9999
                      ? voteStats.sum?.toLocaleString('de-CH')
                      : voteStats.sum}{' '}
                    autres participants.
                  </>
                )}
              </Labels>
            </BarChartTextCol>
            <div className='right'>
              {voteStats.barchartdata &&
                voteStats.thirds &&
                userinputs.weight && (
                  <BarChart
                    lang={tenant?.lang}
                    caffeineAverage={voteStats.caffeineAverage || 0}
                    healthLine={Math.round(userinputs.weight * 5.7)}
                    userValue={userinputs.caffeine as number}
                    thirdsData={voteStats.thirds as any}
                    rawData={voteStats.barchartdata}
                  />
                )}
            </div>
          </TwoCols>
        </>
      )}{' '}
      <p>
        {lang === 'de' ? (
          <>
            Eine allgemeingültige Definition, was eine Tasse Kaffee ist, gibt es
            nicht. Angaben dazu, wie viel Koffein in einer Tasse steckt,
            variieren stark. Das{' '}
            <TamediaLink href='https://www.coffeeness.de/koffein-labor-test/#infografik1'>
              Berliner Institut für Produktqualität
            </TamediaLink>{' '}
            hat im Labor den Koffeingehalt nach verschiedenen Zubereitungsarten
            berechnet. Auf Basis dieser Zahlen haben wir den Koffeingehalt
            beliebter Kaffeegetränke in der Schweiz bestimmt.{' '}
            {userinputs.weight && (
              <>
                Bei den Getränken, die Sie anfangs ausgewählt haben, rechnen wir
                mit Durchschnittswerten.
              </>
            )}
          </>
        ) : (
          <>
            Il n'existe pas de définition universelle de ce qu'est une tasse de
            café. Les données relatives à la quantité de caféine contenue dans
            une tasse varient fortement.{' '}
            <TamediaLink href='https://www.coffeeness.de/koffein-labor-test/#infografik1'>
              L'institut berlinois
            </TamediaLink>{' '}
            pour la qualité des produits a calculé en laboratoire la teneur en
            caféine selon différents modes de préparation. Sur la base de ces
            chiffres, nous avons déterminé la teneur en caféine des boissons au
            café les plus populaires en Suisse.{' '}
            {userinputs.weight && (
              <>
                Pour les boissons que vous avez sélectionnées au début, nous
                avons calculé des valeurs moyennes.
              </>
            )}
          </>
        )}
      </p>
    </>
  )
}

const BarChartTextCol = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  line-height: 1.2em;
  gap: 15px;
  flex-direction: column;
  margin-bottom: 60px;
`
const TwoCols = styled.div`
  margin-top: 60px;
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
  max-width: valc(100vw - 40px);
  letter-spacing: 0.3px;
  font-weight: 300;
  .mobileonly {
    max-width: calc(100vw - 40px);
    line-height: 1.2em;
    @media screen and (min-width: 712px) {
      display: none;
    }
  }
  .desktoponly {
    max-width: calc(100vw - 40px);
    line-height: 1.2em;
    @media screen and (max-width: 712px) {
      display: none;
    }
  }
  .left {
    flex: 0 0 calc(35% - 30px);
    padding-right: 10px;
  }
  .right {
    flex: 0 0 calc(100% - 35%);
  }
  @media screen and (max-width: 711px) {
    flex-wrap: wrap;
    .left {
      flex: 0 0 calc(100vw - 40px);
    }
    .right {
      flex: 0 0 calc(100vw - 40px);
    }
  }
`
const AverageSign = () => {
  return (
    <svg width={25} height={18}>
      {' '}
      <g transform='translate(10,11)'>
        <g>
          <circle
            r={5.5}
            style={{
              stroke: 'var(--coffee-light)',
              fill: 'none',
              strokeWidth: 2
            }}
          />
          <line
            x1={-6}
            x2={6}
            y1={6}
            y2={-6}
            style={{
              stroke: 'var(--coffee-light)',
              fill: 'none',
              strokeWidth: 2
            }}
          />
        </g>
      </g>
    </svg>
  )
}
